import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useT } from "@/i18n/useT";

export default function JournalPostPage() {
  const t = useT();
  const j = t.journal;
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get("/journal").then(({ data }) => setPost((data.posts || []).find((p) => p.slug === slug) || null)); }, [slug]);
  if (!post) return <div className="br-container py-40 text-center text-walnut italic">{t.product.loading}</div>;
  return (
    <article data-testid="journal-post" className="bg-cream">
      <section className="relative h-[60vh] min-h-[420px] overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${post.image})` }} />
        <div className="absolute inset-0 bg-espresso/35" />
        <div className="relative h-full br-container flex items-end pb-16">
          <div className="text-cream max-w-3xl br-fade-in">
            <div className="text-[11px] uppercase tracking-[0.4em] text-amber mb-6">{j.eyebrowLabel}</div>
            <h1 className="font-serif text-4xl md:text-6xl leading-tight">{post.title}</h1>
          </div>
        </div>
      </section>
      <section className="br-container py-24 max-w-3xl">
        <div className="text-lg font-light text-dark-walnut leading-[1.85] space-y-7 whitespace-pre-line br-fade-in">{post.body}</div>
        <div className="mt-20 pt-10 border-t border-walnut/20">
          <Link to="/journal" className="br-link-underline text-xs uppercase tracking-[0.3em]">{j.backToJournal}</Link>
        </div>
      </section>
    </article>
  );
}